import React from "react";
import "./profile-tables.scss";
import {Badge, Pagination, Tooltip} from 'antd';
import {Link} from "react-router-dom";
import {EyeOutlined} from "@ant-design/icons";


const ProfileTables = () => {

    const data = [
        {
            id: 20,
            systemName: `Программное обеспечение искусственного интеллекта "Железный человек" Военно-воздушных сил Соединенных Штатов Америки`,
            applicant: "Военно-воздушные силы Соединенных штатов Америки",
            owner: "Военно-воздушные силы Соединенных штатов Америки",
            workType: 5,
            year: 2022,
            ContractType: "ПГЗ",
            conclusion: "Не соответствует",
            status: "Завершено",
            conclusionIndicator: "error",
            statusIndicator: "success"
        },
        {
            id: 19,
            systemName: `Геоинформационный портал земельного кадастра города Париж`,
            applicant: "Французская Республика",
            owner: "Французская Республика",
            workType: 4,
            year: 2022,
            ContractType: "ПГЗ",
            conclusion: "Не соответствует",
            status: "Завершено",
            conclusionIndicator: "error",
            statusIndicator: "success"
        },
        {
            id: 18,
            systemName: `Геоинформационный портал г.Милан`,
            applicant: "Итальянская Республика",
            owner: "Итальянская Республика",
            workType: 5,
            year: 2022,
            ContractType: "ПГЗ",
            conclusion: "Не соответствует",
            status: "Завершено",
            conclusionIndicator: "error",
            statusIndicator: "success"
        },
        {
            id: 17,
            systemName: `Программное обеспечение "Конор Макгрегор"`,
            applicant: "Соединенное королевство Великобритании и Северной Ирландии",
            owner: "Соединенное королевство Великобритании и Северной Ирландии",
            workType: 4,
            year: 2022,
            ContractType: "не ПГЗ",
            conclusion: "Не соответствует",
            status: "Завершено",
            conclusionIndicator: "error",
            statusIndicator: "success"
        },
        {
            id: 16,
            systemName: "Интернет-портал Systems",
            applicant: "АО ГТС",
            owner: "АО ГТС",
            workType: 5,
            year: 2022,
            ContractType: "не ПГЗ",
            conclusion: "Соответствует",
            status: "Завершено",
            conclusionIndicator: "success",
            statusIndicator: "success"
        },
    ];


    return (
        <div className="profile-table-container">
            <div className="card">
                <div className="card-body">
                    <div className="card-title">Таблица испытаний</div>
                    <table>
                        <thead>
                        <tr>
                            <th>Объект испытания</th>
                            <th>Заявитель</th>
                            <th>Владелец</th>
                            <th>Виды испытаний</th>
                            <th>Год</th>
                            <th>Вид договора</th>
                            <th>Заключение</th>
                            <th>Статус</th>
                            <th>Посмотреть</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.map((system) => (
                            <tr key={system.id}>
                                <td>{system.systemName}</td>
                                <td>{system.applicant}</td>
                                <td>{system.owner}</td>
                                <td>{system.workType}</td>
                                <td>{system.year}</td>
                                <td>{system.ContractType}</td>
                                <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                <td><Badge status={system.statusIndicator}/>{system.status}</td>
                                <td>
                                    <Link to={`/systems/completed/${system.id}`} style={{textDecoration: "none"}}>
                                        <button className="viewButton">
                                            <Tooltip title="Посмотреть">
                                                <EyeOutlined />
                                            </Tooltip>
                                        </button>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <div className="pagination">
                        <Pagination defaultCurrent={1} total={50}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProfileTables;
